import React from 'react';
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

interface SparklineProps {
  data: number[];
  color?: string;
  width?: number | string;
  height?: number | string;
}

export function Sparkline({ data, color = '#8B66FF', width = 100, height = 28 }: SparklineProps) {
  const values = Array.isArray(data) ? data.filter((n) => typeof n === 'number' && isFinite(n)) : [];
  const min = values.length ? Math.min(...values) : 0;
  const max = values.length ? Math.max(...values) : 1;
  const range = Math.max(max - min, 1e-6);
  // Normalize to 0..1 to emphasize intraday shape in a tiny chart
  const normalized = values.map((v) => (v - min) / range);
  const series = normalized.map((y, i) => ({ x: i, y }));
  if (series.length === 0) {
    return null;
  }
  const gradientId = React.useId();

  return (
    <div style={{ width, height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={series} margin={{ top: 3, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.6} />
              <stop offset="100%" stopColor={color} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <YAxis domain={[0, 1]} hide />
          <XAxis dataKey="x" hide />
          <Area type="monotoneX" dataKey="y" stroke={color} fill={`url(#${gradientId})`} strokeWidth={1.5} isAnimationActive={false} />
          <Tooltip content={() => null} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}


